import { EndpointDetailsBaseDataProvider } from './EndpointDetailsBaseDataProvider';
import { EndpointDetailsWebComponentSchema } from '../types';

export class EndpointDetailsNirvanaDataProvider extends EndpointDetailsBaseDataProvider {
  async getEndpointDetails(endpointId: string): Promise<EndpointDetailsWebComponentSchema> {
    return this.dependencies.api.clients.ProtectedEntities.getProtectedEntityDetailsByEndpointId(
      endpointId
    ).toPromise();
  }
}
